var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"exit-button"},[_c('router-link',{staticClass:"exit-text",attrs:{"to":"/"}},[_vm._v(" Exit "),_c('img',{staticClass:"exit-image",attrs:{"src":"/img/monster_slayer/environment/door.gif"}})])],1)}
var staticRenderFns = []

export { render, staticRenderFns }